import { routeCodes } from '@/constants/routes'
import QuizPage from '@/pages/QuizPage/QuizPage'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Navigate, Route, Routes } from 'react-router'
import { useOryUpdateToken } from './api/ory/useOry'
import Layout from './components/layout'
import { getCookie } from './helpers'
import { setTokenCookie } from './helpers/cookies'
import AuthLayout from './pages/auth'
import SupportPage from './pages/SupportPage/SupportPage'
import { setAccessToken } from './store/auth'

const Router = () => {
  const accessToken = useSelector((state: { auth: { accessToken: string } }) => state.auth.accessToken)
  const refreshToken = useSelector((state: { auth: { refreshToken: string } }) => state.auth.refreshToken)
  const accessTokenFromCookie = getCookie('access_token')
  const refreshTokenFromCookie = getCookie('refresh_token')
  const quizIdFromCookie = getCookie('quiz_id')
  const dispatch = useDispatch()
  const {
    oryUpdateToken
    // , oryUpdateTokenError
  } = useOryUpdateToken(refreshTokenFromCookie)
  // console.log('🚀 ~ Router ~ oryUpdateToken access_token:', oryUpdateToken?.access_token)
  // console.log('🚀 ~ Router ~ oryUpdateToken refresh_token:', oryUpdateToken?.refresh_token)
  // console.log('🚀 ~ Router ~ oryUpdateTokenError message:', oryUpdateTokenError?.message)

  useEffect(() => {
    if (oryUpdateToken?.access_token) {
      dispatch(setAccessToken(oryUpdateToken?.access_token))
      // dispatch(setRefreshToken(oryUpdateToken?.refresh_token))
      setTokenCookie('access_token', oryUpdateToken?.access_token)
      setTokenCookie('refresh_token', oryUpdateToken?.refresh_token)
    } else {
      if ((!accessToken && accessTokenFromCookie) || accessToken !== accessTokenFromCookie) {
        dispatch(setAccessToken(accessTokenFromCookie))
      }

      // if ((!refreshToken && refreshTokenFromCookie) || refreshToken !== refreshTokenFromCookie) {
      //   dispatch(setRefreshToken(refreshTokenFromCookie))
      // }
    }
  }, [accessToken, accessTokenFromCookie, dispatch, oryUpdateToken, refreshToken, refreshTokenFromCookie])

  if (!accessToken) {
    return (
      <Routes>
        <Route element={<AuthLayout />}>
          <Route path={routeCodes.SUPPORT} element={<SupportPage />} />
        </Route>
      </Routes>
    )
  }

  if (accessToken) {
    return (
      <>
        <Routes>
          <Route element={<Layout />}>
            <Route path={routeCodes.QUIZ} element={<QuizPage />} />
            <Route path={routeCodes.SUPPORT} element={<SupportPage />} />
            <Route path='/' element={<Navigate to={`/surveys/${quizIdFromCookie}`} />} />
            <Route path='/surveys/null' element={<Navigate to={`/surveys/${quizIdFromCookie}`} />} />
            <Route path='*' element={<Navigate to={`/surveys/${quizIdFromCookie}`} replace />} />
          </Route>
        </Routes>
      </>
    )
  }

  return null
}

export default Router
